/**
 * @tabler/icons-react v2.39.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconKeyframeAlignCenterFilled = createReactComponent(
  "keyframe-align-center-filled",
  "IconKeyframeAlignCenterFilled",
  [
    [
      "path",
      {
        d: "M12 19a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M12 6c-.629 0 -1.214 .301 -1.606 .807l-2.908 3.748a2.395 2.395 0 0 0 -.011 2.876l2.919 3.762c.39 .505 .977 .807 1.606 .807c.629 0 1.214 -.301 1.606 -.807l2.908 -3.748a2.395 2.395 0 0 0 .011 -2.876l-2.919 -3.762a2.032 2.032 0 0 0 -1.606 -.807z",
        fill: "currentColor",
        key: "svg-1",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M12 1a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z",
        fill: "currentColor",
        key: "svg-2",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M5 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z",
        fill: "currentColor",
        key: "svg-3",
        strokeWidth: "0"
      }
    ],
    [
      "path",
      {
        d: "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z",
        fill: "currentColor",
        key: "svg-4",
        strokeWidth: "0"
      }
    ]
  ]
);

export { IconKeyframeAlignCenterFilled as default };
//# sourceMappingURL=IconKeyframeAlignCenterFilled.js.map
